import { styled, alpha } from "@mui/material/styles";
import {
  Dialog as MuiDialog,
  DialogTitle as MuiDialogTitle,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  Button,
  Divider,
  Grid,
} from "@mui/material";

const WHITE = "rgb(255, 255, 255)";
const ALPHA_WHITE_BACKGROUND = alpha(WHITE, 0.2);
const BLACK = "rgb(0, 0, 0)";
const ALPHA_BLACK_BACKGROUND = alpha(BLACK, 0.2);
const GREY = "rgb(210, 210, 210)";

export const Dialog = styled(MuiDialog, {
  shouldForwardProp: (prop) => prop !== "editMode",
})<{ editMode: boolean }>(
  {
    "& .MuiPaper-root": {
      transition: "all .8s ease",
    },
  },
  ({ editMode, theme }) => ({
    ...(!editMode && {
      "& .MuiPaper-root.MuiDialog-paper": {
        backgroundColor: theme.palette.secondary.dark,
      },
    }),
  })
);

export const DialogTitle = styled(MuiDialogTitle, {
  shouldForwardProp: (prop) => prop !== "editMode",
})<{ editMode: boolean }>(
  ({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    color: theme.palette.primary.contrastText,

    "& .MuiIconButton-root": {
      padding: "5px 10px",
      color: theme.palette.primary.contrastText,
      transition: "all .5s ease",
    },

    "& .MuiIconButton-root:hover": {
      backgroundColor: ALPHA_WHITE_BACKGROUND,
    },
  }),
  ({ editMode, theme }) => ({
    ...(editMode && {
      color: theme.palette.primary.contrastText,

      "& .MuiIconButton-root": {
        color: theme.palette.text.primary,
      },

      "& .MuiIconButton-root:hover": {
        backgroundColor: ALPHA_BLACK_BACKGROUND,
      },
    }),
  })
);

export const DialogContent = styled(MuiDialogContent)({
  overflow: "hidden",
});

export const InitialImgContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "bgImage",
})<{ bgImage: string }>(
  {
    width: "100%",
    height: "400px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ({ bgImage }) => ({
    ...(bgImage && {
      backgroundImage: `url(${bgImage})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    }),
  })
);

export const CropperContainer = styled(Grid)({
  width: "100%",
  height: "400px",
  position: "relative",

  "& > div": {
    width: "100%",
    height: "100%",
  },
});

export const DialogActions = styled(MuiDialogActions)({
  display: "flex",
  flexFlow: "column",
  alignItems: "flex-end",

  "& > .MuiGrid-root, & > .MuiDivider-root": {
    width: "100%",
  },
});

export const EditUtilsContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  padding: "0 0 0 10px",

  "& > .MuiGrid-root": {
    width: "35%",
    display: "flex",
    flexWrap: "wrap",

    "& .MuiTypography-root": {
      width: "50%",
      fontSize: ".8em",
      fontWeight: "bold",
    },

    "& .MuiTypography-root:last-of-type": {
      textAlign: "right",
    },
  },
});

export const DialogActionsDivider = styled(Divider)({
  borderColor: GREY,
  margin: "10px 0",
});

export const UtilsButtonsContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  padding: "0 10px 15px",

  "& > .MuiGrid-root": {
    display: "flex",
    gap: "15px",
  },
});

export const UtilsButton = styled(Button)(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  gap: "7px",
  textTransform: "none",
  color: theme.palette.primary.contrastText,
  transition: "all .4s ease",

  "&:hover": {
    backgroundColor: ALPHA_WHITE_BACKGROUND,
  },

  "& svg": {
    fontSize: "1.5em",
  },

  "& .MuiTypography-root": {
    fontSize: "1.2em",
  },
})) as typeof Button;

export const SaveImageButton = styled(Button)({
  borderRadius: "20px",
  textTransform: "none",
  fontSize: "1em",
});
